export const ScheduleTypes = {
    AVAILABILITIES: 'availabilities',
    BY_DATE: 'byDate',
    USER_CLASSES: 'userClasses',
    PAST: 'past',
    FUTURE: 'future',
    LATE_CANCELLATION: 'lateCancellation',
};

